import { alpha, Box, Chip, Stack, Typography, useTheme } from '@mui/material';

import { AlgorithmsStatus } from '../../types';

interface AlgorithmStatusCellProps {
  algorithmsStatus: AlgorithmsStatus[];
}

const AlgorithmStatusCell = ({
  algorithmsStatus,
}: AlgorithmStatusCellProps) => {
  const theme = useTheme();

  if (!algorithmsStatus.length) {
    return (
      <Typography
        variant='subtitleNumbers'
        component='span'
        color='textSecondary'
      >
        N/A
      </Typography>
    );
  }

  return (
    <Stack gap={2} alignItems='flex-start'>
      {algorithmsStatus.map(({ id, status }) => {
        const isPending = status === 'pending';
        const isPendingRemoval = status === 'pending_removal';

        let textColor = theme.palette.success.main;
        let backgroundColor = alpha(theme.palette.success.main, 0.1);
        let text = 'Applied';

        if (isPending) {
          textColor = theme.palette.warning.main;
          backgroundColor = alpha(theme.palette.warning.main, 0.1);
          text = 'Pending application';
        } else if (isPendingRemoval) {
          textColor = theme.palette.error.main;
          backgroundColor = alpha(theme.palette.error.main, 0.1);
          text = 'Pending removal';
        }

        return (
          <Chip
            key={id}
            label={
              <Stack direction='row' alignItems='center' gap={0.75}>
                <span>
                  <Box
                    sx={{ backgroundColor: textColor }}
                    width={6}
                    height={6}
                    borderRadius='50%'
                  />
                </span>
                {text}
              </Stack>
            }
            size='small'
            sx={{
              fontFamily: (theme) => theme.typography.subtitleLabel.fontFamily,
              fontSize: '0.75rem',
              lineHeight: '1.125rem',
              color: textColor,
              backgroundColor: backgroundColor,
            }}
          />
        );
      })}
    </Stack>
  );
};

export default AlgorithmStatusCell;
